"use strict";

var $ = require("jquery");

function dropdownHeight(el, breakpoint = 992) {
    if ($(window).width() < breakpoint) {
        const navbarHeight = $('.header-bottom-wrapper').outerHeight();
        const vh = window.innerHeight;
        const dropdownHeight = vh - navbarHeight + 10;
        el.outerHeight(dropdownHeight);
    } else {
        el.css({ 'height': '' });
        el.css({ 'top': '' });
    }
}

export { dropdownHeight };